module.exports = __webpack_public_path__ + "img/sug2.9dad7b25.png";